import color from "../../../../../constants/color";

const styles = {
  heading:{
    fontSize:"20px",
    fontWeight:"600",
  },
  gridContainer: {
    px:"15px",
    pt:"7px",
    py: 1,
    display: "flex",
    justifyContent:"space-between", 
    mt:2
  },
  graph: {
    " & svg" :{
      width: "100%"
    } 
  },
  reportHeading: {
    fontSize: "18px",
    fontWeight: "600",
    mb:2
  },
  purchase: {
    fontSize: "12px",
    fontWeight: "400",

  },
  grid: {
    display: "flex",
    mt:1
  },
  keySec: {
    width: "50%",
  },
  key: {
    fontSize: "14px",
    fontWeight: "500",
    color: color.lightText
  },
  value: {
    fontSize: "20px",
    fontWeight: "500",
    color: color.text
  },

  gridbox: {
    // alignItems:"center",
    backgroundColor: color.card,
    borderRadius: "20px",
    p: 2,
    mb:{ xs:2, md: 2 ,lg: 0},
    // justifyContent: "space-between",
  },
  greenDot:{
    backgroundColor:color.primary,
    height:"12px",
    width:"12px",
    borderRadius: "50%",
    mr:1,
    mt: "4px"
  },

  TableHead: {
    color: color.lightText,
    fontWeight: "400",

  },
  tabledata: {
    borderBottom: 0,
  },
  tableAvtardata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center",
  },

  tableActiondata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center", 
    gap: "12px"
  },
  label:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text
  },
  deleteIcon: {
    color:"#ff0000"
  },
  input:{
    width:"100%",
    borderRadius: "8px",
    my: 1,
    height: "2.5em",
    marginBottom:"1em"
  },
  space:{
    my:2
  },
  modalInput:{
    display:"flex",    // backgroundColor:color.lightGray,
    borderRadius:"30px",
    // width:{ xs: "25em", md: "35em" },
    justifyContent:"center" ,// Center align on smaller screens
    my:"10px",
    height:"2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"8.5px 14px"
    },
    "& .MuiOutlinedInput-root":{
      padding:"0"
    }
  },
  inputSpace: {
    "& .MuiOutlinedInput-root":{
      padding:"0px 14px"
    }

  },
  calenderInput:{
    "& .MuiInputBase-input": {
      padding: "8.5px 14px"
    }
  },  
  noteInput:{
    height:"4.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"14px"
    },
  },
  calender:{
    borderRadius:"5px",
  },
  statusFilter:{
    position:"fixed",
    py:1,
    px:2
  },
  filterText:{
    fontSize:"12px",
    fontWeight:"500",
    mr:"2em"
  },
  width:{
    mr:{xs:0, md:"7px"}
  },
  widths:{
    // mr:{xs:0, md:2}
  },

  containerInput:{
    display: {sx: "block", md:"flex"},
    // flexDirection:"row"
  },
  fromTogrid:{
    display: "flex",
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"space-between"
  },
  statusBtn:
   {border:"1px solid #28AA4A ",
     borderRadius:"10px",
     ml:5,
     mx: {xs: "20px"},
     mt:{xs: "15px", sm: "5px"},
     width: "fit-content",
   },
  name:{
    color:color.text,
    fontSize:"14px",
    fontWeight:"400",
    textTransform:"capitalize"

  },
  mail:{
    color:color.lightText,
    fontSize:"14px",
    fontWeight:"400"
  },  
  row:{
    display:"flex",
    flexDirection:"row",
    justifyContent:"center",
    alignItems:"center",
    pl:4
  },
  checkinBtn:
  { borderRadius: 50, 
    backgroundColor: color.secondary,
    color: "#fff", 
    ml: "8px" ,
    textTransform: "none", 
    fontSize: "12px",
    boxShadow:"none"

  },
  checkoutBtn: {
    borderRadius: 50, 
    backgroundColor: "#28AA4A",
    color: "#fff", 
    ml: "8px",
    textTransform: "none",
    fontSize: "12px",
    boxShadow:"none"
  },
  exportbtn: {
    borderRadius: 50, 
    textTransform: "none" , 
    backgroundColor: color.secondary,
    // mr: "10px", 
    // my: 4,
    alignItems: "center",
    fontSize: "12px",
    px: 3,

  },
  viewIcon: {
    color: color.lightText,
    fontSize: "1.3rem",
  },
  emailIcon: {
    mr: 1, 
    fontSize:"0px"
  },



};
export default styles;